import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Eye, Image as ImageIcon, Home, Briefcase } from 'lucide-react';
import { WhatsAppButton } from './WhatsAppButton';
export function Services() {
  const services = [{
    icon: Eye,
    title: 'Videncia Personalizada',
    description: 'Obtén orientación sobre amor, trabajo, relaciones, proyectos y decisiones importantes.',
    ctaText: 'Más información',
    message: 'Hola Maestro Navy, deseo más información sobre el servicio de Videncia Personalizada.'
  }, {
    icon: ImageIcon,
    title: 'Fotomancia',
    description: 'Análisis energético mediante fotografía para identificar bloqueos, influencias y aspectos relevantes de tu situación.',
    ctaText: 'Solicitar evaluación',
    message: 'Hola Maestro Navy, me interesa solicitar una evaluación de Fotomancia.'
  }, {
    icon: Home,
    title: 'Limpieza Energética de Hogares',
    description: 'Armonización y limpieza energética de espacios para recuperar equilibrio, bienestar y tranquilidad.',
    ctaText: 'Consultar servicio',
    message: 'Hola Maestro Navy, quiero consultar por el servicio de Limpieza Energética de Hogares.'
  }, {
    icon: Briefcase,
    title: 'Limpieza Energética para Negocios',
    description: 'Evaluación y armonización energética de emprendimientos, oficinas y negocios.',
    ctaText: 'Consultar disponibilidad',
    message: 'Hola Maestro Navy, deseo consultar disponibilidad para la Limpieza Energética de Negocios.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-24 px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-199">
      <div className="max-w-7xl mx-auto" data-id="element-200">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-201">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold mb-6" data-id="element-202">
            Servicios <span className="text-gradient-gold" data-id="element-203">disponibles</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-mystic-gold to-transparent mx-auto rounded-full" data-id="element-204"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-205">
          {services.map((service, index) => <motion.div key={index} variants={cardVariants} className="glass-panel p-8 rounded-2xl flex flex-col h-full group hover:border-mystic-gold/40 transition-all duration-500 relative overflow-hidden" data-id="element-206">
              {/* Subtle hover glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-mystic-gold/0 to-mystic-blue-800/0 group-hover:from-mystic-gold/5 group-hover:to-mystic-blue-800/20 transition-all duration-500" data-id="element-207"></div>

              <div className="relative z-10 flex-grow" data-id="element-208">
                <div className="w-16 h-16 rounded-2xl bg-mystic-black border border-mystic-gold/20 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500 shadow-[0_0_15px_rgba(212,175,122,0.1)]" data-id="element-209">
                  <service.icon className="w-8 h-8 text-mystic-gold" data-id="element-210" />
                </div>

                <h3 className="text-2xl font-serif font-semibold text-mystic-white mb-4 group-hover:text-mystic-gold-light transition-colors" data-id="element-211">
                  {service.title}
                </h3>

                <p className="text-mystic-white/70 leading-relaxed mb-8 font-light" data-id="element-212">
                  {service.description}
                </p>
              </div>

              <div className="relative z-10 mt-auto pt-6 border-t border-mystic-gold/10" data-id="element-213">
                <WhatsAppButton text={service.ctaText} variant="outline" message={service.message} className="w-full" data-id="element-214" />
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}